<div class="flyout-portal" *ngIf="isShopRelatedPage" [class.inScroll]="inScroll">
  <div class="shop-navigation">
    <div class="nav-scroll-wrapper">
      @if (onClient) {
        <div class="fade fade-left" [class.hidden]="atStart"></div>

        <div class="fade fade-right" [class.hidden]="atEnd"></div>
      }

      <ul #scrollWrapper (scroll)="onScroll()">
        <li *ngFor="let category of categoryTree; let i = index">
          @if (
            (currentPath && category.url.startsWith(currentPath)) || mainCategoryActiveIndex === i
          ) {
            <app-link
              [link]="category.url"
              [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i"
              class="active-item"
            >
              <span>{{ category.name }}</span>
            </app-link>
          } @else {
            <app-link
              [link]="category.url"
              [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i"
            >
              <span>{{ category.name }}</span>
            </app-link>
          }
        </li>
      </ul>
    </div>
  </div>
</div>
